import { render, staticRenderFns } from "./LogMenuReducido.vue?vue&type=template&id=0b76d867&scoped=true"
import script from "./LogMenuReducido.vue?vue&type=script&lang=js"
export * from "./LogMenuReducido.vue?vue&type=script&lang=js"
import style0 from "./LogMenuReducido.vue?vue&type=style&index=0&id=0b76d867&prod&lang=scss"
import style1 from "./LogMenuReducido.vue?vue&type=style&index=1&id=0b76d867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76d867",
  null
  
)

export default component.exports